export const isLoading = (state) => state.auth.isLoading
export const error = (state) => state.auth.error
